import {register} from '@shopify/theme-sections'
import $ from 'jquery'
import '../../styles/sections/section-flexible-video.scss'

export default register(`section-flexible-video`, {
    onLoad() {
        $(document).on(`click`, `.bottom-link-flip`, function() {
            $(this).parents(`.new-video-content`).addClass(`active`)
        })
        $(document).on(`click`, `.bottom-link-flip-back`, function() {
            $(this).parents(`.new-video-content`).removeClass(`active`)
        })
        
        let videoWrappers = document
            .getElementById(`shopify-section-${this.id}`)
            .querySelectorAll(`.rte__video-wrapper`)
        
        videoWrappers.forEach((wrapper) => {
            let video = wrapper.querySelector(`video`)
            if (video) {
                video.addEventListener(`play`, () => {
                    wrapper.classList.add(`video-active`)
                })
                video.addEventListener(`pause`, () => {
                    wrapper.classList.remove(`video-active`)
                    if (wrapper.classList.contains(`video-has-poster`)) {
                        video.removeAttribute(`controls`)
                    }
                })
            }
            
            if (wrapper.classList.contains(`video-has-poster`)) {
                wrapper.addEventListener(`click`, () =>{
                    video.play()
                    video.setAttribute(`controls`, `control`)
                })
            }
        })
        
        let videos = document.querySelectorAll(`.rte__video-wrapper video`)
        videos.forEach(video => {
            video.addEventListener(`play`, () => {
                videos.forEach(otherVideo => {
                    if (!otherVideo.paused && otherVideo !== video) {
                        otherVideo.pause()
                    }
                })
            })
        })
    },
    onUnload() {

    },
})
